module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"save_before_cancel":"編集内容を保存しますか？","menu":{"add":"追加","cancel":"キャンセル","pick":"選択","control":"操作","save":"保存する"}},"en":{"save_before_cancel":"Do you want to save your changes?","menu":{"add":"Add","cancel":"Cancel","pick":"Pick","control":"Pan & Zoom","save":"Save"}}}')
  delete Component.options._Ctor
}
